import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AreaFormacaoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all AreaFormacao
  list(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: any[] }>(
        `${this.path}/getAllAreaFormacao`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params
      )
      .pipe(map((response) => response));
  }

  // Create new AreaFormacao
  public store(form: any): Observable<any> {
    const areaFormacao = form;
    return this.apiService
      .post<{ object: any }>(`${this.path}/AddAreaFormacao`, areaFormacao)
      .pipe(map((response) => response.object));
  }

  // Update existing AreaFormacao
  public update(form: FormGroup, id: string): Observable<any> {
    const areaFormacao = form.value;
    return this.apiService
      .put<{ object: any }>(`${this.path}/UpdateAreaFormacao/${id}`, areaFormacao)
      .pipe(map((response) => response.object));
  }

  // Delete existing AreaFormacao
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteAreaFormacaoById/${id}`);
  }

  // Get AreaFormacao by ID
  public show(id: string): Observable<any> {
    return this.apiService
      .get<{ object: any }>(`${this.path}/getAreaFormacaoById/${id}`)
      .pipe(map((response) => response.object));
  }
}
